import { FC, useMemo } from 'react';
import IconFont from '../../IconFont';
import { markTypeEnum } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import { isArray } from '@lhb/func';
import SiteMapExplainExtra, { ParagraphProps } from '@/common/components/business/SiteMap/SiteMapExplainExtra';

/**
 * @Description 评分介绍icon
 */
const ScoreExplaimIcon:FC<{
  data: any; // 商圈数据
  predictSale: any; // 是否展示预测营业额
  className?: any;
}> = ({
  data,
  predictSale,
  className,
}) => {

  /**
   * @description 获取评分描述
   * @param data
   * @returns
   */
  const getExtraParagraph = () => {
    const { markType, scores } = data || {};
    if (markTypeEnum.four !== markType) return null;
    if (!isArray(scores) || !scores.length) return null;

    const filtered = scores.filter(itm => !!itm.name && !!itm.msg);
    if (!filtered.length) return null;

    const parag: ParagraphProps = {
      title: '评分说明',
      descriptions: filtered.map(itm => `${itm.name}：${itm.msg}`)
    };
    return parag;
  };

  const extraParagraph = useMemo(() => {
    return getExtraParagraph();
  }, [data]);


  return (
    <IconFont
      iconHref='iconxq_ic_shuoming_normal'
      className={className}
      tooltipConfig={{
        placement: 'bottom',
        overlayInnerStyle: {
          width: '320px',
          padding: '16px',
          boxSizing: 'border-box',
          borderRadius: '4px',
          maxHeight: 'calc(50vh)',
          overflowY: 'auto',
        },
        title: <SiteMapExplainExtra
          markType={data?.markType}
          isPredictSale={predictSale}
          extraParagraphs={extraParagraph ? [extraParagraph] : []}
        />,
      }}/>
  );
};

export default ScoreExplaimIcon;
